/**
 */

define('directives/myservices/secureUrl/secureUrl.directives',['app','mainCons'], function (app,mainCons) {
    app.directive('secureUrl', ['HuaweiTrade','OpenApp',function (HuaweiTrade,OpenApp) {
        var timeout;
        return {
            restrict: 'E',
            replace: true,
            require: "?ngModel",
            templateUrl: '../refactor/directives/myservices/secureUrl/secureUrl.html',
            link: function ($scope, $element, attrs,ngModelCtrl) {

                $scope.regexp = mainCons.servicesConstant.regexp;

                $scope.Model.secureUrlList=angular.copy(mainCons.appConstant.secureUrlList);

                if($scope.Model.product.isUpdate)
                {
                    OpenApp.getAppDetail({
                        request:{
                            appID:$scope.Model.product.prodID
                        }
                    }).then(function (data) {
                        if(data && data.resultCode === 0){
                            if(data.appInfo.appAttrs &&angular.fromJson(data.appInfo.appAttrs).secureUrlList)
                            {
                                $scope.Model.secureUrlList=angular.fromJson(data.appInfo.appAttrs).secureUrlList;
                            }
                            if(data.appInfo.appAttrs&&angular.fromJson(data.appInfo.appAttrs).oauthRedirectUri)
                            {
                                $scope.Model.selected.callbackUrl=angular.fromJson(data.appInfo.appAttrs).oauthRedirectUri;
                            }
                        }
                    });
                }

                $scope.validSecurlUrl=(function(){
                    return {
                        test:function(value){
                            return checkParams(value, $scope.regexp.secureUrl);
                        }
                    }
                })();

                //校验
                $scope.checkParams = checkParams;
                function checkParams(str, reg) {
                    return (new RegExp(reg)).test(str);
                }
            }
        }
    }]);
});
